
import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './ethics.json';

const Ethics = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Moral dilemmas, ethical frameworks, and philosophy vocabulary. B2/C1 level reading, grammar, and discussion exercises."
            level="B2"
            title="Ethics"
            image="/Images/eding1.webp"
            seoTitle="Free English Lesson Plans: Ethics"
            seoDescription="Moral dilemmas, ethical frameworks, and philosophy vocabulary. B2/C1 level reading, grammar, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Ethics;


